if (!customElements.get('collection-filter-toggle')) {
  customElements.define(
    'collection-filter-toggle',
    class CollectionFilterToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.layout = this.closest('.collection-design-layout');

        if (!this.button || !this.layout) return;

        this.button.addEventListener('click', this.onToggle);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
      }

      onToggle = () => {
        const filtersAreHidden = this.layout.classList.toggle('collection-design-layout--filters-hidden');
        this.button.setAttribute('aria-expanded', String(!filtersAreHidden));
      };
    }
  );
}
